import { SupportedCountry } from '../types';
import { supabase } from './supabase';

export const getSupportedCountries = async (): Promise<SupportedCountry[]> => {
  const { data, error } = await supabase
    .from('supported_countries')
    .select('*')
    .eq('is_supported', true);
  if (error) {
    throw new Error(error.message);
  }
  return data;
};
